export { default } from './VersionCompareContent';
